import { AnchoredHeading } from '@squareup/dex-ui';
import { Box, Heading30 } from '@squareup/dex-ui-shared-base';
import clsx from 'clsx';
import React, { FunctionComponent, ReactNode } from 'react';

import styles from './reference-code-example-aside-layout.module.css';

interface ReferenceCodeExampleAsideLayoutProps {
  exampleSwitcher?: ReactNode;
  versionSwitcher: ReactNode;
  requestCodeBlock: ReactNode;
  responseCodeBlock?: ReactNode;
}

const ReferenceCodeExampleAsideLayout: FunctionComponent<
  ReferenceCodeExampleAsideLayoutProps
> = ({
  exampleSwitcher,
  versionSwitcher,
  requestCodeBlock,
  responseCodeBlock,
}) => {
  const response = responseCodeBlock ? (
    <Box margin={{ bottom: '5x' }} className={clsx(styles['code-block'])}>
      {responseCodeBlock}
    </Box>
  ) : null;

  return (
    <>
      <AnchoredHeading
        className={styles['example-heading']}
        anchor="example-code"
        trackingId="example-code"
      >
        <Heading30>Examples</Heading30>
      </AnchoredHeading>
      <Box
        data-testid="reference-page-aside"
        className={styles['floating-block']}
      >
        <Box margin={{ bottom: '2x' }} className={clsx(styles.top)}>
          <Box>{exampleSwitcher}</Box>
          {versionSwitcher && (
            <Box className={styles['version-switcher']}>{versionSwitcher}</Box>
          )}
        </Box>
        <Box
          margin={{ bottom: '2x' }}
          className={clsx(styles['code-block'], styles.request)}
        >
          {requestCodeBlock}
        </Box>
        {response}
      </Box>
    </>
  );
};

export { ReferenceCodeExampleAsideLayout };
